import { enums, IEnums } from 'utils/configs/enums';

export type IEnumsState = IEnums;

export const enumsReducer = (): IEnumsState => {
  return enums;
};
